import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_VISITORS = createAsyncActionTypes('FETCH_VISITORS');